module.exports = __webpack_public_path__ + "static/media/alladin1.0fc40263.gif";